import { useIntl } from "../../lib/i18n";

export default function SectionsHarnessPage() {
  const { t } = useIntl();
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("sections.harness.title")}</h1>
      <p className="mt-4 text-slate-500">{t("sections.harness.empty")}</p>
    </div>
  );
}
